import { type Components, type Theme } from "@mui/material/styles";

export const muiSwitchOverrides: Components<Theme> = {
  MuiSwitch: {
    defaultProps: {
      disableRipple: true,
      focusVisibleClassName: ".Mui-focusVisible",
      color: "primary",
    },
    styleOverrides: {
      root: {
        width: 42,
        height: 26,
        padding: 0,

        variants: [
          {
            props: { size: "small" },
            style: {
              width: 34,
              height: 20,

              "& .MuiSwitch-switchBase": {
                margin: 2,
                padding: 0,
                "&.Mui-checked": {
                  transform: "translateX(14px)",
                },
              },

              "& .MuiSwitch-thumb": {
                width: 16,
                height: 16,
              },

              "& .MuiSwitch-track": {
                borderRadius: 20 / 2,
              },
            },
          },
        ],
      },
      switchBase: ({ theme, ownerState }) => {
        const color = ownerState.color ?? "primary";
        const paletteColor = color !== "default" ? theme.palette[color]?.main : undefined;

        return {
          padding: 0,
          margin: 2,
          transitionDuration: "300ms",
          "&.Mui-checked": {
            transform: "translateX(16px)",
            color: theme.palette.common.white,
            "& + .MuiSwitch-track": {
              backgroundColor: paletteColor ?? theme.palette.primary.main,
              opacity: 1,
              border: 0,
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.5,
            },
          },
          "&.Mui-focusVisible .MuiSwitch-thumb": {
            color: paletteColor ?? theme.palette.primary.main,
            border: `6px solid ${theme.palette.common.white}`,
          },
          "&.Mui-disabled .MuiSwitch-thumb": {
            color: theme.palette.common.white,
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.7,
          },
        };
      },
      thumb: {
        boxSizing: "border-box",
        width: 22,
        height: 22,
      },
      track: ({ theme }) => ({
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.background.inactive,
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
          duration: 500,
        }),
      }),
    },
  },
};
